import assessment from './platform/assessment.js'
import nct from './platform/NeurologicalClinicalThinking.js'
import oldPeopleHome from './platform/oldPeopleHome.js'
import ecctt from './platform/ecctt.js'
import InteractiveCourse from './platform/InteractiveCourse.js'
import documents from './platform/documents.js'
import tool from './tool.js'

import index from './platform/index.js'
import personalCenter from './platform/personalCenter.js'
import course from './platform/course.js'
import exam from './platform/course/exam.js'
import webgl from './platform/course/webgl.js'
import question from './platform/course/question.js'
import sso from './platform/sso.js'
import other from './platform/other.js'
import frailtyCalc from './platform/frailtyCalc.js'

export default [{
		path: '/scan-exam',
		component: () => import('../views/scanExam/index')
	}, {
		path: '/',
		component: () => import('../views/platform/index'),
		redirect: '/login',
		children: [{
				path: 'home',
				component: () => import('../views/platform/home'),
				redirect: '/home/meCourse',
				children: [
					...index,
					...personalCenter,
					...course
				]
			},
			...sso,
			...question,
			...exam,
			...webgl,
			...InteractiveCourse,
			...oldPeopleHome,
			...assessment,
			...nct,
			...documents,
			...other,
			...ecctt,
			...frailtyCalc
		]
	},
	...tool
]